import { render } from "./Footer.vue?vue&type=template&id=5d4ba78b&ts=true"
import script from "./Footer.vue?vue&type=script&lang=ts"
export * from "./Footer.vue?vue&type=script&lang=ts"

import "./Footer.vue?vue&type=style&index=0&id=5d4ba78b&lang=scss"

import exportComponent from "/home/runner/work/platform/platform/website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__